import { FieldAttributes, FieldConfig, Field as FormikField } from "formik";
import { useAlternativeFormik } from "../hooks";
import { useCalculationField } from "@ploy-lib/calculation";

type AlternativeFormikFieldProps<T = any> = FieldAttributes<T> & {
	altComponent?: FieldConfig<T>["component"];
};

/**
 *
 * @param param0 Make formik patch up internal field with value from variables
 * @returns
 */
function AlternativeFormikField({
	altComponent: Component,
	field: formikField,
	form: formikForm,
	...rest
}: AlternativeFormikFieldProps) {
	const [namespace, fieldname] = formikField.name.split(".");
	const calculation = useCalculationField(namespace, fieldname);

	const { form, field } = useAlternativeFormik(
		formikField,
		formikForm,
		calculation.value
	);

	if (!Component) {
		return null;
	}

	return <Component {...rest} form={form} field={field} />;
}

/**
 * Use me instead FormikField when handling fields that are _not_ sumitted, but should be available from CalcRules
 * @param param0
 * @returns
 */
export function CalcRuleFormikField({
	component,
	...rest
}: FieldAttributes<any>) {
	return (
		<FormikField
			component={AlternativeFormikField}
			{...rest}
			altComponent={component}
		/>
	);
}
